<template>
    <div>
        <div v-if="show" class="school-box school-box-diff">
            <Breadcrumb></Breadcrumb>
            <el-row class="zy-school" type="flex" justify="space-between">
                <el-col :span="24">
                    <div class="rank-box zy-list">
                        <div class="search-img header-search">
                            <el-input placeholder="查学校" v-model="searchSchool.scl_name"
                                @input="searchSchoolListHandler">
                                <template slot="append">
                                    <img src="../../assets/images/sousuo.png" alt="搜索" @click="searchSchoolListHandler"
                                        @mouseenter="isShowSearch = true" @mouseleave="isShowSearch = false"
                                        v-if="!isShowSearch">
                                    <img src="../../assets/images/sousuo-diff.png" alt="搜索"
                                        @click="searchSchoolListHandler" @mouseenter="isShowSearch = true"
                                        @mouseleave="isShowSearch = false" v-if="isShowSearch">
                                </template>
                            </el-input>
                        </div>

                        <div class="province-list">
                            <div class="title-box">省份名称：</div>
                            <div class="province-name">
                                <a v-for="(item, index) in provinceList" :key="'province-' + index"
                                    :class="activeTag == index ? 'active-tag' : ''"
                                    @click="activeProvinceHandler(item, index)">
                                    {{ item.name }}
                                </a>
                            </div>
                        </div>

                        <div class="province-list">
                            <div class="title-box">是否双一流：</div>
                            <div class="province-name">
                                <a v-for="(item, index) in dualClassList" :key="'dual-' + index"
                                    :class="activeTag1 == index ? 'active-tag' : ''"
                                    @click="activeDualClassHandler(index)">
                                    {{ item.name }}
                                </a>
                            </div>
                        </div>

                        <div class="province-list">
                            <div class="title-box">是否有研究生院：</div>
                            <div class="province-name">
                                <a v-for="(item, index) in graduateSchoolList" :key="'graduate-' + index"
                                    :class="activeTag2 == index ? 'active-tag' : ''"
                                    @click="activeGraduateSchoolHandler(index)">
                                    {{ item.name }}
                                </a>
                            </div>
                        </div>

                        <div class="province-list">
                            <div class="title-box">是否自主划线：</div>
                            <div class="province-name">
                                <a v-for="(item, index) in independentLineList" :key="'line-' + index"
                                    :class="activeTag3 == index ? 'active-tag' : ''"
                                    @click="activeIndependentLineHandler(index)">
                                    {{ item.name }}
                                </a>
                            </div>
                        </div>

                        <el-row class="collapse-box" v-if="searchSchoolStatus">
                            <div class="collapse-list" v-for="(item, index) in schoolList" :key="item.scl_id">
                                <el-col :span="3">
                                    <img :src="item.logo" alt="大学logo" ref="schoolImg" @error="nofindImg(index)">
                                    <transition v-on:before-enter="beforeEnter" v-on:enter="enter"
                                        v-on:after-enter="afterEnter">
                                        <div class="ball" v-if="showImage">
                                            <img class="active-img-inner active-img-inner-hook"
                                                :src="schoolList[showImageIndex].logo" alt="大学logo">
                                        </div>
                                    </transition>
                                </el-col>

                                <el-col :span="17">
                                    <div class="zytb-school-name">
                                        <span class="zytb-school-title" @click="schoolDetailHandler(item.school_id)">{{
                                            item.scl_name }}</span>
                                        <img src="../../assets/images/wz.png" alt="位置" v-if="item.city_name">
                                        <span v-if="item.city_name">
                                            {{ item.province_name == '北京' || item.province_name == '天津' ||
                                                item.province_name == '上海' ||
                                            item.province_name == '重庆' ? '' : item.province_name }}{{ item.city_name }}
                                        </span>
                                    </div>
                                    <div class="zytb-school-tag">
                                        <span v-if="item.school_nature_type">{{ item.school_nature_type }}</span>
                                        <span v-if="item.school_type">{{ item.school_type }}</span>
                                        <span v-if="item.school_nature">{{ item.school_nature }}</span>
                                        <span v-if="item.f211 == '1'"
                                            style="background:#fff4e3;color:#fe9f0a;">211</span>
                                        <span v-if="item.f985 == '1'"
                                            style="background:#fff0e9;color:#ff6b35;">985</span>
                                        <span v-if="item.dual_class"
                                            style="background:#e4f4e9;color:#01c13b;">双一流</span>
                                        <span v-if="item.has_graduate_school"
                                            style="background:#eef4ff;color:#4c6fff;">研究生院</span>
                                        <span v-if="item.independent_line"
                                            style="background:#fff0f3;color:#df4d75;">自主划线</span>
                                        <span v-if="item.is_provincial == '1'"
                                            style="background:#FDEFFF;color:#D250E0;">省重点</span>
                                    </div>
                                </el-col>

                                <el-col :span="4">
                                    <!-- <el-button class="school-compare" v-if="!item.pk" @click.native="addCompare(item, index)">
                                        <img src="../../assets/images/add.png" alt="加入对比">
                                        加入对比
                                    </el-button>
                                    <el-button class="school-compare-diff" v-else @click="removeCompare(item, index)">
                                        <img src="../../assets/images/cancel.png" alt="取消对比">
                                        取消对比
                                    </el-button> -->
                                </el-col>

                                <div class="con-clear"></div>
                                <el-row class="con-line"></el-row>
                            </div>

                            <el-pagination background layout="prev, pager, next, jumper" :total="totalData"
                                :page-size="pageSize" @current-change="getDiffSchoolListHandler"
                                :current-page.sync="currentPage" v-if="totalData > pageSize">
                            </el-pagination>
                        </el-row>

                        <div v-if="!searchSchoolStatus" class="no-data-box">
                            <img src="../../assets/images/null.png" alt="没有数据">
                            <p>没有查询到学校</p>
                        </div>
                    </div>
                </el-col>

                <!-- <el-col :span="8" class="zyb-box">
                    <SchoolNewsCard title="招生简章" :school-id="currentSchoolId" :news-type="1" class="zyb-card"
                        @item-click="handleSidebarNewsClick" />

                    <SchoolNewsCard title="信息公告" :school-id="currentSchoolId" :news-type="2" class="zyb-card"
                        @item-click="handleSidebarNewsClick" />

                    <SchoolNewsCard title="网报公告" :school-id="currentSchoolId" mode="netReport" class="zyb-card"
                        @item-click="handleSidebarNewsClick" />

                    <SchoolNewsCard title="调剂办法" :school-id="currentSchoolId" :news-type="3" class="zyb-card"
                        @item-click="handleSidebarNewsClick" />
                </el-col> -->
            </el-row>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
import { getSchoolListAPI } from "@/api/postgraduate.js"
import { getSearchDic } from "@/api/zhiyuan.js"

const DEFAULT_LOGO = require("../../assets/images/scl_default.png")

export default {
    name: "school",
    data () {
        return {
            show: true,
            currentPage: 1,
            pageSize: 15,
            isShowSearch: false,
            totalData: 0,
            schoolList: [],
            searchSchoolStatus: true,
            showImage: false,
            showImageIndex: null,
            compareSchoolList: [],

            activeTag: 0,
            activeTag1: 0,
            activeTag2: 0,
            activeTag3: 0,

            searchSchool: {
                scl_name: ""
            },

            filters: {
                province: "",
                is_syl: "",
                is_yjsy: "",
                is_zhx: ""
            },

            provinceList: [
                { name: "全部", provinceid: "" }
            ],

            dualClassList: [
                { name: "全部", value: "" },
                { name: "是", value: 1 },
                { name: "否", value: 0 }
            ],

            graduateSchoolList: [
                { name: "全部", value: "" },
                { name: "是", value: 1 },
                { name: "否", value: 0 }
            ],

            independentLineList: [
                { name: "全部", value: "" },
                { name: "是", value: 1 },
                { name: "否", value: 0 }
            ]
        }
    },
    computed: {
        currentSchoolId () {
            if (this.schoolList.length === 1) {
                return this.schoolList[0].school_id
            } else {
                return ""
            }
        }
    },
    created () {
        this.getSearchDicHandler()
        this.getSchoolListHandler(1)
    },
    methods: {
        handleSidebarNewsClick (item) {
            // console.log(item, "sidebar item")
            this.$router.push({
                path: "/pgdetail",
                query: {
                    id: item.id,
                    scl_id: this.currentSchoolId,
                    // type:''
                }
            })
        },
        schoolDetailHandler (scl_id) {
            this.$router.push({
                path: "/pgsdetail",
                query: {
                    scl_id: scl_id
                }
            })
        },

        getSearchDicHandler () {
            getSearchDic().then(res => {
                const data = res.data || {}
                if (data.province && Array.isArray(data.province)) {
                    // console.log(data.province, "province")
                    this.provinceList = [
                        { name: "全部", provinceid: "" },
                        ...data.province
                    ]
                    // console.log(this.provinceList, "provinceList")
                }
            })
        },

        activeProvinceHandler (item, index) {
            // console.log(item,'item')
            this.activeTag = index
            this.filters.province = item.name==='全部'?'':(item.name || "")
            this.getSchoolListHandler(1)
        },

        activeDualClassHandler (index) {
            this.activeTag1 = index
            this.filters.is_syl = this.dualClassList[index].value
            this.getSchoolListHandler(1)
        },

        activeGraduateSchoolHandler (index) {
            this.activeTag2 = index
            this.filters.is_yjsy = this.graduateSchoolList[index].value
            this.getSchoolListHandler(1)
        },

        activeIndependentLineHandler (index) {
            this.activeTag3 = index
            this.filters.is_zhx = this.independentLineList[index].value
            this.getSchoolListHandler(1)
        },

        searchSchoolListHandler () {
            this.getSchoolListHandler(1)
        },

        getSchoolListHandler (page = 1) {
            this.currentPage = page

            const province = this.filters.province
            // console.log(province, "province")
            const name = this.searchSchool.scl_name || ""
            const is_syl = this.filters.is_syl
            const is_yjsy = this.filters.is_yjsy
            const is_zhx = this.filters.is_zhx

            getSchoolListAPI(
                this.currentPage,
                this.pageSize,
                province,
                name,
                is_syl,
                is_yjsy,
                is_zhx
            ).then(res => {
                const pageData = res.data || {}
                const list = pageData.data || []
                // console.log(list, "list")
                this.totalData = pageData.total || 0
                this.pageSize = pageData.per_page || this.pageSize
                this.currentPage = pageData.current_page || this.currentPage
                this.searchSchoolStatus = list.length > 0

                this.schoolList = list.map(item => {
                    return {
                        school_id: item.id,
                        scl_id: item.scl_code,
                        scl_name: item.scl_name,
                        province_name: "",
                        city_name: item.scl_city,
                        school_nature_type: "",
                        school_type: "",
                        school_nature: item.scl_dept || "",
                        f211: "0",
                        f985: "0",
                        dual_class: item.is_syl == 1 ? "1" : "",
                        has_graduate_school: item.is_yjsy == 1,
                        independent_line: item.is_zhx == 1,
                        is_provincial: "0",
                        pk: this.compareSchoolList.indexOf(item.scl_code) !== -1,
                        logo: item.icon_url || ""
                    }
                })
            })
        },

        getDiffSchoolListHandler (page) {
            this.getSchoolListHandler(page)
        },

        addCompare (item, index) {
            if (this.compareSchoolList.length === 4) {
                this.$message({
                    message: "最多可添加4所院校",
                    type: "warning"
                })
                return
            }

            if (this.compareSchoolList.indexOf(item.scl_id) === -1) {
                this.compareSchoolList.push(item.scl_id)
            }

            this.showImage = true
            this.showImageIndex = index
            this.$set(this.schoolList, index, {
                ...this.schoolList[index],
                pk: true
            })
        },

        removeCompare (item, index) {
            const removeIndex = this.compareSchoolList.indexOf(item.scl_id)
            if (removeIndex !== -1) {
                this.compareSchoolList.splice(removeIndex, 1)
            }

            this.$set(this.schoolList, index, {
                ...this.schoolList[index],
                pk: false
            })
        },

        beforeEnter (el) {
            const schoolImg = this.$refs.schoolImg && this.$refs.schoolImg[this.showImageIndex]
            if (!schoolImg) return
            const rect = schoolImg.getBoundingClientRect()
            el.style.transform = "translate(10px,10px)"
            el.style.position = "absolute"
            el.style.left = rect.x + "px"
            el.style.top = rect.y + "px"
            el.style.zIndex = "9999"
        },

        enter (el, done) {
            const schoolImg = this.$refs.schoolImg && this.$refs.schoolImg[this.showImageIndex]
            if (!schoolImg) {
                done()
                return
            }
            el.offsetWidth
            const x = document.documentElement.clientWidth
            const y = document.documentElement.clientHeight
            const rect = schoolImg.getBoundingClientRect()
            el.style.position = "fixed"
            el.style.right = "16px"
            el.style.bottom = "332px"
            el.style.transform = "translate(" + (x - 90 - rect.x) + "px," + (y - 500 - rect.y) + "px)"
            el.style.transition = "all 0.5s cubic-bezier(.42, 0, .58, 1)"
            done()
        },

        afterEnter () {
            this.showImage = false
        },

        nofindImg (index) {
            this.$set(this.schoolList, index, {
                ...this.schoolList[index],
                logo: DEFAULT_LOGO
            })
        }
    }
}
</script>


<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.zy-school {
    @include gwidth;

    .el-col-7 {
        width: 32.5%;
    }

    .el-col-16 {
        position: relative;
        padding: 0 20px 0 0;
    }
}

.search-img {
    margin-bottom: 24px;
    height: 44px;
    line-height: 44px;

    img {
        width: 32px;
        height: 32px;
        float: right;
        cursor: pointer;
    }

    input {
        background: #fff !important;
    }

    button {
        width: 100px;
        height: 44px;
        border: none !important;
        background: linear-gradient(270deg, $common-color, #60aaff 99%);
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        border: none;
        margin-left: 16px;
        position: relative;
        top: 1px;
    }
}

.rank-box {
    border: none;
    background: #fff;
    box-shadow: none !important;
    margin-top: 24px;
    padding: 24px;
    border-radius: 8px;
    min-height: 700px;
}

.province-list {
    @include gflex;
    font-size: 0;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 6px;

    .title-box {
        width: 150px;
        font-size: 14px;
        text-align: right;
        color: #909399;
        margin-top: 3px;
    }

    a {
        display: inline-block;
        font-size: 14px;
        color: #5e6166;
        cursor: pointer;
        text-align: center;
        padding: 3px 5px;
        margin-bottom: 10px;
    }

    a:hover {
        color: $common-color;
    }

    a:not(:nth-child(13n)) {
        margin-right: 12px;
    }

    .active-tag {
        color: #ffffff !important;
        background: $common-color;
        border-radius: 4px;
    }

    .province-name {
        @include gflex;
        width: calc(100% - 20px);
        justify-content: flex-start;
        flex-wrap: wrap;
    }
}

.collapse-list {
    height: 104px;
    padding: 20px 0;
    position: relative;
    box-sizing: border-box;
}

.collapse-box {
    width: 100%;
    border-top: 1px solid #f0f2f5;
    margin-top: 24px;
    font-size: 0;

    img {
        width: 64px;
        height: 64px;
    }

    .active-img-inner {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background-color: rgb(0, 160, 220);
    }

    .el-col-3 {
        width: 11%;
    }

    .el-col-4 {
        float: right;
        text-align: right;
    }

    .zytb-school-name {
        font-size: 18px;
        font-weight: 600;
        color: #2c2e33;
        margin-bottom: 5px;

        .zytb-school-title {
            font-size: 18px;
            font-weight: 600;
            color: #2c2e33;
        }
    }

    .zytb-school-tag {
        margin-top: 10px;
    }

    .zytb-school-tag span {
        display: inline-block;
        padding: 3px 8px;
        font-size: 12px;
        color: #909399;
        height: 22px;
        background: #f0f2f5;
        border-radius: 4px;
        line-height: 22px;
        margin-right: 4px;
    }

    .zytb-school-name img {
        width: 16px;
        height: 16px;
        position: relative;
        top: 2px;
        left: 5px;
        margin-left: 5px;
    }

    .zytb-school-name span {
        color: #909399;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        top: -2px;
        left: 5px;
    }

    button {
        width: 100px;
        height: 30px;
        border: 1px solid $common-color;
        border-radius: 5px;
        color: $common-color !important;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        padding: 0;
        margin-top: 15px;
        background-color: #fff;
    }

    .school-compare,
    .school-compare-diff {
        img {
            width: 12px;
            height: 12px;
        }
    }

    .school-compare-diff {
        color: #ffffff !important;
        background: $common-color !important;
        border: 1px solid $common-color !important;
    }

    button:hover {
        background-color: #fff;
    }

    .con-line {
        width: 100%;
        height: 1px;
        background: #f0f2f5;
        position: absolute;
        right: 0;
        bottom: 0;
        // display: none;
    }
}

.collapse-list:hover {
    .zytb-school-title {
        color: $common-color;
        cursor: pointer;
    }
}

.zyb-box {
    position: static;
    right: auto;
}

.no-data-box {
    position: static;
    top: auto;
    left: auto;
    transform: none;
    margin-top: 0;
    padding: 80px 0 40px;
    min-height: 420px;
    text-align: center;

    img {
        width: 110px;
        height: 110px;
    }

    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
    }
}
</style>
